import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // Ensure this path is correct
import store from './store'; // Ensure this path is correct
import "@fortawesome/fontawesome-free/css/all.min.css";


const app = createApp(App)
console.log('NODE MODE:', process.env.NODE_ENV);
console.log('API URL:', process.env.VUE_APP_API_BASE_URL);

// Add global `isLoggedIn` function
app.config.globalProperties.$isLoggedIn = () => {
    return !!localStorage.getItem('jwt'); // Check if token exists
  };

app.use(router)
.use(store)
.mount('#app');
